import type { Materia, Sucursal } from '../types'

export const SUCURSALES: Sucursal[] = [
  {
    id: 'ver',
    clave: 'VER',
    nombre: 'Veracruz',
    direccion: 'Av. Independencia 1145, Col. Centro, C.P. 91700',
    ciudad: 'Veracruz',
    estado: 'Veracruz',
    telefono: '229 118 4400',
    responsableId: 'ab-01',
    activa: true,
  },
  {
    id: 'cmx',
    clave: 'CMX',
    nombre: 'Ciudad de México',
    direccion: 'Río Lerma 232, Piso 6, Cuauhtémoc, C.P. 06500',
    ciudad: 'Ciudad de México',
    estado: 'CDMX',
    telefono: '55 4412 9000',
    responsableId: 'ab-04',
    activa: true,
  },
  {
    id: 'gdl',
    clave: 'GDL',
    nombre: 'Guadalajara',
    direccion: 'Av. Vallarta 1540, Col. Americana, C.P. 44160',
    ciudad: 'Guadalajara',
    estado: 'Jalisco',
    telefono: '33 1450 6600',
    responsableId: 'ab-05',
    activa: true,
  },
  {
    id: 'mty',
    clave: 'MTY',
    nombre: 'Monterrey',
    direccion: 'Ricardo Margáin 575, Valle del Campestre, C.P. 66269',
    ciudad: 'San Pedro Garza García',
    estado: 'Nuevo León',
    telefono: '81 2044 3300',
    responsableId: 'ab-08',
    activa: true,
  },
]

export const MATERIAS: Materia[] = [
  'Penal',
  'Civil',
  'Mercantil',
  'Laboral',
  'Familiar',
  'Administrativo',
  'Amparo',
]

export const CLAVE_MATERIA: Record<Materia, string> = {
  Penal: 'PEN',
  Civil: 'CIV',
  Mercantil: 'MER',
  Laboral: 'LAB',
  Familiar: 'FAM',
  Administrativo: 'ADM',
  Amparo: 'AMP',
}

export const TIPOS_ASUNTO: Record<Materia, string[]> = {
  Penal: ['Fraude', 'Robo agravado', 'Despojo', 'Lesiones', 'Delitos fiscales'],
  Civil: [
    'Juicio ordinario civil',
    'Reivindicatorio',
    'Arrendamiento',
    'Nulidad de contrato',
  ],
  Mercantil: [
    'Juicio ejecutivo mercantil',
    'Cobro de pagaré',
    'Concurso mercantil',
    'Incumplimiento de contrato',
  ],
  Laboral: [
    'Despido injustificado',
    'Reinstalación',
    'Prestaciones devengadas',
    'Riesgo de trabajo',
  ],
  Familiar: [
    'Divorcio incausado',
    'Guarda y custodia',
    'Pensión alimenticia',
    'Sucesión intestamentaria',
  ],
  Administrativo: [
    'Nulidad de multa',
    'Responsabilidad patrimonial',
    'Licencias y permisos',
    'Devolución de impuestos',
  ],
  Amparo: ['Amparo indirecto', 'Amparo directo', 'Amparo contra leyes'],
}

export const AUTORIDADES: string[] = [
  'Juzgado 3° de Distrito en Veracruz',
  'Juzgado 1° Civil de Primera Instancia, Veracruz',
  'Fiscalía Regional Zona Centro, Veracruz',
  'Juzgado 14° Civil de la CDMX',
  'Tribunal Federal de Justicia Administrativa, Sala Metropolitana',
  'Centro de Conciliación Laboral de Jalisco',
  'Juzgado 5° Familiar de Guadalajara',
  'Juzgado 2° de Distrito en Nuevo León',
  'Tribunal Superior de Justicia de N.L., Sala Civil',
  'Juzgado de Control del Sistema Penal Acusatorio, Monterrey',
]
